import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { ProductGroup } from '@prlw/core/products/product-group.entity';
import { IconsModule } from '@prlw/libs/icons/icons.module';
import pluralize from '@prlw/libs/pluralize/pluralize';

@Component({
  selector: 'prlw-basis-counter-label-ui',
  standalone: true,
  imports: [IconsModule, CommonModule],
  templateUrl: './basis-counter-label.component.html',
  styleUrl: './basis-counter-label.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BasisCounterLabelComponent {
  @Input() public totalShipmentsForCurrentProductGroupCount: number | null =
    null;
  @Input() public currentProductGroup: ProductGroup | null = null;
  @Input() public preloaderActive: boolean | null = null;

  @Output() public readonly eventOpenManageOverlay = new EventEmitter<void>();

  getPluralizedLabel() {
    return `${this.totalShipmentsForCurrentProductGroupCount} ${pluralize(
      this.totalShipmentsForCurrentProductGroupCount ?? 0,
      ['базис', 'базиса', 'базисов'],
    )} ${
      this.currentProductGroup
        ? 'по продукту ' +
          this.currentProductGroup.code +
          ' (' +
          this.currentProductGroup.name +
          ')'
        : ''
    }`;
  }
}
